import script from "./BlockMbox.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockMbox.vue?vue&type=script&setup=true&lang=js"

import "./BlockMbox.vue?vue&type=style&index=0&id=6400993a&lang=scss"

const __exports__ = script;

export default __exports__